import { Outlet, useRouteLoaderData } from "react-router";
import { Header, type HeaderExtras } from "~/components/Header";
import { Footer } from "~/components/Footer";
import type { loader } from "./clubs.$clubId/route";

export default function ClubsLayout() {
  const data = useRouteLoaderData<typeof loader>("routes/clubs.$clubId");
  const club = data?.club;
  const extras: HeaderExtras | undefined = club ? {
    primaryLabel: club.name,
    secondaryLabel: club.locationCities.map(city => city.city).join(", ") || undefined,
    indicatorTone: "pink",
    share: {},
  } : undefined;

  return (
    <div className="butter-grain relative min-h-screen flex flex-col items-center text-base bg-butter-cream-light text-butter-green font-sans">
      <div className="relative z-10 w-full flex flex-col items-center">
        <Header extras={extras} />

        <div className="w-full flex flex-col items-center px-5 pt-5 lg:pt-10">
          <Outlet />
        </div>

        <div className="w-full flex flex-col items-center px-5">
          <Footer />
        </div>
      </div>
    </div>
  );
}
